module.exports = {
  APP_SHORT_NAME: "savedlists"
};
